import { atomWithStorage } from 'jotai/utils';

export type ApprovalFilter = "all" | "pending" | "approved";

// Filter atoms with localStorage persistence
export const selectedUserIdsAtom = atomWithStorage<string[]>('documentFilters.userIds', []);
export const selectedTagIdsAtom = atomWithStorage<string[]>('documentFilters.tagIds', []);
export const approvalFilterAtom = atomWithStorage<ApprovalFilter>('documentFilters.approval', 'pending');
export const searchQueryAtom = atomWithStorage<string>('documentFilters.searchQuery', '');
